import { AuthSubscriptions } from '@hefe/auth';
import { t } from '@hefe/i18n';
import { ClubSlice, currentUserSelector } from '@hefe/store';
import { clubHasSubscription } from '@hefe/utils';
import { Col, Divider, Menu, Row, Spin, Tooltip } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import ClubCustomUserAttributesComponent from '../../components/club-custom-user-fields/club-custom-user-attributes.component';
import ClubDataProcessingComponent from '../../components/club-data-processing/club-data-processing.component';
import ClubDetailsComponent from '../../components/club-details/club-details.component';
import ClubPageHeaderComponent from '../../components/club-page-header/club-page-header.component';
import ClubPracticeTimesFrameComponent from '../../components/club-practice-times-frame/club-practice-times-frame.component';
import ClubPressCenterSettingsComponent from '../../components/club-press-center-settings/club-press-center-settings.component';
import ClubProspectsSettingsComponent from '../../components/club-prospects-settings/club-prospects-settings.component';
import ClubSettingsComponent from '../../components/club-settings/club-settings.component';
import ClubSubscriptionsComponent from '../../components/club-subscriptions/club-subscriptions.component';
import ClubWelcomeTextComponent from '../../components/club-welcome-text/club-welcome-text.component';

export default function ClubPage() {
  const dispatch = useAppDispatch();
  const club = useSelector(ClubSlice.clubSelector);
  const user = useSelector(currentUserSelector);

  const [loading, setLoading] = useState(false);

  const [activeTab, setActiveTab] = useState('details');

  useEffect(() => {
    fetchClub();
  }, []);

  const tabs = useMemo(() => {
    const returnValue = [];

    const welcomeTextAllowed = clubHasSubscription(
      AuthSubscriptions.second,
      user
    );
    const customUserAttributesAllowed = clubHasSubscription(
      AuthSubscriptions.third,
      user
    );

    const prospectsAllowed = clubHasSubscription(AuthSubscriptions.third, user);

    const pressCenterAllowed = clubHasSubscription(
      AuthSubscriptions.third,
      user
    );

    returnValue.push({
      key: 'details',
      label: t('details'),
      //children: <ClubDetailsComponent club={club} />,
    });

    returnValue.push({
      key: 'welcome_text',
      label: welcomeTextAllowed ? (
        t('welcome_text')
      ) : (
        <Tooltip title={t('errors.permissions.second')}>
          {t('welcome_text')}
        </Tooltip>
      ),
      disabled: !welcomeTextAllowed,
      //children: <ClubWelcomeTextComponent club={club} />,
    });

    returnValue.push({
      key: 'custom_user_attributes',
      label: customUserAttributesAllowed ? (
        t('custom_user_attributes.title')
      ) : (
        <Tooltip title={t('errors.permissions.third')}>
          {t('custom_user_attributes.title')}
        </Tooltip>
      ),
      disabled: !customUserAttributesAllowed,
      //children: <ClubCustomUserAttributesComponent club={club} />,
    });
    /*
    returnValue.push({
      key: 'subscriptions',
      label: t('subscriptions.title'),
      //children: <ClubSubscriptionsComponent club={club} />,
    });
    */
    // data processing agreement
    returnValue.push({
      key: 'data_processing_agreement',
      label: t('data_processing.title'),
      //children: <ClubDataProcessingComponent club={club} />,
    });

    returnValue.push({
      key: 'prospects',
      label: prospectsAllowed ? (
        t('prospects.settings.title')
      ) : (
        <Tooltip title={t('errors.permissions.third')}>
          {t('prospects.settings.title')}
        </Tooltip>
      ),
      disabled: !prospectsAllowed,
    });

    returnValue.push({
      key: 'practice_times',
      label: t('practices.administration.practice_times.title'),
    });

    returnValue.push({
      key: 'press_center',
      label: pressCenterAllowed ? (
        t('press_center.settings.title')
      ) : (
        <Tooltip title={t('errors.permissions.third')}>
          {t('press_center.settings.title')}
        </Tooltip>
      ),
      disabled: !pressCenterAllowed,
    });

    returnValue.push({
      key: 'settings',
      label: t('settings.title'),
      //children: <ClubDetailsComponent club={club} />,
    });

    return returnValue.map((item) => ({
      ...item,
      style: {
        color: 'black',
      },
    }));
  }, [user, club]);

  const activeTabComponent = useMemo(() => {
    switch (activeTab) {
      case 'details':
        return <ClubDetailsComponent club={club} />;
      case 'welcome_text':
        return <ClubWelcomeTextComponent club={club} />;
      case 'custom_user_attributes':
        return <ClubCustomUserAttributesComponent club={club} />;
      case 'subscriptions':
        return <ClubSubscriptionsComponent club={club} />;
      case 'data_processing_agreement':
        return <ClubDataProcessingComponent club={club} />;
      case 'prospects':
        return <ClubProspectsSettingsComponent club={club} />;
      case 'press_center':
        return <ClubPressCenterSettingsComponent club={club} />;
      case 'practice_times':
        return <ClubPracticeTimesFrameComponent club={club} />;
      case 'settings':
        return <ClubSettingsComponent club={club} />;
      default:
        return null;
    }
  }, [activeTab, club]);

  const fetchClub = () => {
    setLoading(true);
    dispatch(ClubSlice.fetchClub())
      .unwrap()
      .catch(() => null)
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <Spin size="large" />;
  }

  /*
  return (
    <div>
      <Row justify="center" style={{ marginBottom: 24 }}>
        <Col>
          <ClubPageHeaderComponent club={club} />
        </Col>
      </Row>
      <Row justify="center">
        <Col xs={24} md={12}>
          <Tabs items={tabs} />
        </Col>
      </Row>
    </div>
  );
  */

  return (
    <div>
      <Row justify="center" style={{ marginBottom: 24 }}>
        <Col>
          <ClubPageHeaderComponent club={club} />
        </Col>
        <Divider />
      </Row>
      <Row justify="center">
        <Col xs={24} md={8} lg={6}>
          <Menu
            onClick={(tab) => setActiveTab(tab.key.toString())}
            defaultSelectedKeys={[activeTab]}
            mode="inline"
            theme="light"
            items={tabs}
          />
        </Col>
        <Col xs={24} md={16} lg={18} style={{ padding: 26 }}>
          {activeTabComponent}
        </Col>
      </Row>
    </div>
  );
}
